import {Typography} from '@mui/material';
import {t} from 'i18next';
import React from 'react';
import AurButton from '../../common/aur-button/AurButton';
import AurUserCreatorDetails from './AurUserCreatorDetails';
import AurProfilePicture from '../../common/aur-profile-picture/AurProfilePicture';
import AurPill from '../../common/aur-pill/AurPill';
import {initailLabelDetails, labelProps} from './models';
import {ADD_NEW_TEAM_MEMBER} from '../../../constants/constants';
import {useSelector} from 'react-redux';
import {RootState} from '../../../redux/store';

interface Props {
  userId: string;
  userFirstName: string; //user first name
  userLastName: string; //use last name
  userEmail: string; //user email id
  creatorDetails: boolean; // depending upon true/false to show the creator details section
  createdByName?: string; // user createdBy Name
  updatedByName?: string; // user updatedBy Name
  createdByDate?: string; // user createdOn Date
  updatedByDate?: string; // user updatedOn Date
  profileIconBgColor?: string; // random background color is assigned to profile icon while user creation, passing static value for now.
  onClick: React.MouseEventHandler<HTMLButtonElement>; // edit button on click action function
  labelDetails?: labelProps[];
  flowName?: string;
}

const AurUserDetailsView: React.FC<Props> = (props: Props) => {
  const {
    userId,
    userFirstName,
    userLastName,
    userEmail,
    creatorDetails,
    createdByName,
    updatedByName,
    createdByDate,
    updatedByDate,
    onClick,
    labelDetails = initailLabelDetails,
    flowName,
  } = props;

  const loggedInUserId = useSelector(
    (state: RootState) => state.user.user?.userId
  );

  const labelContainer = () => {
    return labelDetails.map((index) =>
      index.icon ? (
        <AurPill
          label={index.status}
          icon={index.icon}
          iconColor={index.iconColor}
          fontColor={index.fontColor}
          iconSize={index.iconSize}
        />
      ) : (
        ''
      )
    );
  };

  return (
    <div className={`aur-user-details-main-container`}>
      <div className="aur-user-profile-picture-container">
        <AurProfilePicture
          bgColor={true}
          displayText={
            userFirstName?.charAt(0).toUpperCase() +
            userLastName?.charAt(0).toUpperCase()
          }
          iconSize={91}
          borderRadius={2.84}
          textSize="Medium"
          iconType="User"
        />
      </div>

      <div className="aur-user-details-container">
        <div className="aur-user-name-container">
          <div className="name-field">
            <Typography
              className={`typo-text display2_size grey-color-100 name-typo`}
              title={`${userFirstName} ${userLastName}`}
              component="h1"
            >
              {`${userFirstName} ${userLastName}`}
            </Typography>
          </div>

          {(userId != loggedInUserId || flowName === ADD_NEW_TEAM_MEMBER) && (
            <div
              className={`${
                flowName === ADD_NEW_TEAM_MEMBER
                  ? 'add-new-team-member-edit-button'
                  : 'aur-user-edit-details-button'
              }`}
            >
              <AurButton
                type="secondary"
                label={t('buttons.editDetails')}
                onClick={onClick}
                size="Medium"
              />
            </div>
          )}
        </div>
        <Typography
          className={`typo-text body1_size mist-color-1400 word-break-all`}
        >
          {userEmail}
        </Typography>
        <div className="aur-user-label-main-container">
          <div className="aur-user-label-container">{labelContainer()}</div>
          {creatorDetails && (
            <div className="aur-user-label-creator-container">
              <AurUserCreatorDetails
                createdBy={createdByName}
                updatedBy={updatedByName}
                createdDate={createdByDate}
                updatedDate={updatedByDate}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AurUserDetailsView;
